/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InteraccionesPrincipiosActivosDto } from '../../models/interacciones-principios-activos-dto';

export interface DoctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Params {
  interaccionUuid: string;
}

export function doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid(http: HttpClient, rootUrl: string, params: DoctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Params, context?: HttpContext): Observable<StrictHttpResponse<InteraccionesPrincipiosActivosDto>> {
  const rb = new RequestBuilder(rootUrl, doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid.PATH, 'get');
  if (params) {
    rb.path('interaccionUuid', params.interaccionUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InteraccionesPrincipiosActivosDto>;
    })
  );
}

doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid.PATH = '/api/principios-activos/interacciones/{interaccionUuid}';
